export { default as itemOfProductModalShape } from './itemOfProductModal';
export { default as productShape } from './product';
export { default as productLineShape } from './productLine';
export { default as discountOptionsShape } from './discountOptions';
export { default as discountsShape } from './discounts';
export { default as userShape } from './user';
export { default as channelShape } from './channel';



// WEBPACK FOOTER //
// ./src/model/Types/index.js